import React, { FC } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import NavLink from 'components/app-header/nav-link';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { routes } from 'utils/routing';

import { ILeftNav } from '../types';

const StyledExternalLink = styled.a`
  text-decoration: none;
  color: currentColor;
  font-family: ${Styles.fontFamily.base};
  font-size: 1.125rem;
  margin-left: 1.3rem;

  &.active,
  &:hover {
    text-decoration: none;
  }

  &:first-of-type {
    margin-left: 0;
  }

  &:active,
  &.active {
    color: ${Styles.color.tertiary};
  }

  &.active,
  &:hover {
    color: ${Styles.color.tertiary};
  }
`;

const NavList = styled.ul`
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  align-items: center;
`;

export const StaticLeftNav: FC<ILeftNav> = ({ orderHref, handleClick }) => {
  const { formatMessage } = useIntl();
  const enableCatering = useFlag(LaunchDarklyFlag.ENABLE_CATERING);

  return (
    <>
      <NavList>
        <li>
          <NavLink data-testid="order-desktop" to={orderHref} onClick={handleClick}>
            {formatMessage({ id: 'order' })}
          </NavLink>
        </li>
        <li>
          {enableCatering ? (
            <NavLink to={routes.catering} onClick={handleClick}>
              {formatMessage({ id: 'catering' })}
            </NavLink>
          ) : (
            <StyledExternalLink href="https://catering.bojangles-us.com" onClick={handleClick}>
              {formatMessage({ id: 'catering' })}
            </StyledExternalLink>
          )}
        </li>
      </NavList>
    </>
  );
};
